import { observer } from 'mobx-react';
import ProgramStore from '../../../ProgramStore';
import SegmentStore from '../../../SegmentStore';
import { AlreadyTranslated } from '../../../Translations';
import { useTranslationsContext } from '../../../Translations/UseTranslationsContext';
import WhenLink from '../../../WhenLink';
import Image from '../../Image';
import SegmentPanel from '../../SegmentPanel';
import Title from '../Title';

interface Props {
  segmentStore: SegmentStore;
  programStore: ProgramStore;
}

/**
 * The top of the segment page: the university logo, program title and segment title on
 * the left, and the course tools on the right. Logos are uploaded at very different
 * shapes (from about 1.7:1 to 11:1), so the logo is capped by both height and width.
 */
function SegmentHeader({ segmentStore, programStore }: Props) {
  const { translate } = useTranslationsContext();

  return (
    <div className="mb-4 flex flex-col gap-4 px-4 sm:flex-row sm:items-end sm:justify-between sm:px-0">
      <div className="min-w-0">
        {programStore.programDetailResource
          .map((resource) => (
            <>
              <WhenLink rel="logo-on-white" links={resource.links}>
                {({ href }) => (
                  <Image
                    src={href}
                    alt={translate('University partner logo')}
                    className="mb-2 block h-auto max-h-10 w-auto max-w-[300px]"
                    data-test-university-logo={true}
                  />
                )}
              </WhenLink>
              <div
                className="text-base font-semibold text-gray-600"
                data-test-current-program-title={resource.payload.title}
              >
                <AlreadyTranslated content={resource.payload.title} />
              </div>
            </>
          ))
          .getOrElse(() => (
            <></>
          ))}
        <Title title={segmentStore.title} />
      </div>
      <SegmentPanel segmentStore={segmentStore} programStore={programStore} />
    </div>
  );
}

export default observer(SegmentHeader);
